<template>
  <div class="border p-4 rounded-lg mt-4 border-gray-200 cursor-pointer" @click="expanded = !expanded">
    <div class="flex justify-between items-center font-bold">
      {{ formatDate(pipelineReview.created_at) }}
      <vue-feather
        type="chevron-right"
        class="h-4 transition-all transform ease-in-out duration-300 delay-0"
        :class="{ 'rotate-90': expanded, 'rotate-0': !expanded }"
      />
    </div>

    <div v-if="expanded" class="mt-4 border-t border-gray-200 pt-4 -ml-4 -mr-4 px-4">
      <PreviousPipelineReview :pipeline-review="pipelineReview" :teammate="teammate" />
    </div>
  </div>
</template>

<script>
import { formatStandardDate } from '../../utilities/format.js';
import PreviousPipelineReview from './PreviousPipelineReview.vue';

export default {
  components: {
    PreviousPipelineReview,
  },
  props: {
    pipelineReview: {
      type: Object,
      required: true,
    },
    teammate: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    formatDate(date) {
      return formatStandardDate(date);
    },
  },
};
</script>
